import { ColumnModal } from "./types";
import { t } from "i18next";

export const initialColumnModalState: ColumnModal = {
  isColumnModal: false,
  isDataTypeModal: false,
  columnDataType: { name: t("ColumnModal.テキスト"), type: "string" },
  isOpenColumnMemu: false,
};
